import { render } from "./AlgeriaPage.vue?vue&type=template&id=fd895a76&scoped=true"
import script from "./AlgeriaPage.vue?vue&type=script&lang=js"
export * from "./AlgeriaPage.vue?vue&type=script&lang=js"

import "./AlgeriaPage.vue?vue&type=style&index=0&id=fd895a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd895a76"]])

export default __exports__